import { Button, Stack, Typography } from '@mui/material';
import { TooltipRenderProps } from 'react-joyride';

const OnboardingTooltip = ({ step, primaryProps, skipProps, tooltipProps, isLastStep }: TooltipRenderProps) => {
    return (
        <Stack
            {...tooltipProps}
            sx={{
                maxWidth: 400,
                backgroundColor: 'common.white',
                padding: 4,
                borderRadius: 1,
            }}
        >
            <Typography variant="body2">{step.content}</Typography>
            <Stack
                direction="row"
                sx={{
                    justifyContent: 'flex-end',
                    marginTop: 4,
                    gap: 2,
                }}
            >
                {!isLastStep && (
                    <>
                        <Button variant="text" {...skipProps} data-dd-action-name="Skip tour">
                            Skip
                        </Button>
                        <Button {...primaryProps} variant="contained" color="info">
                            Next
                        </Button>
                    </>
                )}
                {isLastStep && (
                    <Button {...primaryProps} data-dd-action-name="Finish tour" color="success">
                        Finish
                    </Button>
                )}
            </Stack>
        </Stack>
    );
};

export default OnboardingTooltip;
